import React from 'react';
import AppImage from '~/components/shared/AppImage';

import { ArrowRoundedLeft7x11Svg, ArrowRoundedRight7x11Svg } from '~/svg';
import AppLink from '../shared/AppLink';

const BLOGS_DATA = [
    {
        url: '/blogs/air-filter',
        image: '/images/product/AirFilter.png',
        keyId: 1,
        label: 'Understanding the Importance of Air Filters for Your Car',
    },
    {
        url: '/blogs/brake-oil',
        image: '/images/product/BrakeFluid.png',
        keyId: 2,
        label: 'Vmotive: The Premium Choice for Brake Oil',
    },
    {
        url: '/blogs/brake-pads',
        image: '/images/product/BrakePad.png',
        keyId: 3,
        label: 'Vmotive: The Leading Brand in Automotive Brake Pads',
    },
    {
        url: '/blogs/engine-flush',
        image: '/images/product/EngineFlush.png',
        keyId: 4,
        label: "Vmotive Engine Flush: The Ultimate Solution for Keeping Your Car's Engine in Top Condition",
    },
    {
        url: '/blogs/engine-oils',
        image: '/images/product/MettlePlus.png',
        keyId: 5,
        label: 'Vmotive: High-Quality Engine Oils for Your Car',
    },
    {
        url: '/blogs/fuel-filter',
        image: 'https://storage.googleapis.com/fixcraft-public/spare-parts-ecom/v-motive/family/FUEL%20FILTER.png',
        keyId: 6,
        label: 'Vmotive: The Leading Automobile Brand for High-Quality Fuel Filters',
    },
    {
        url: '/blogs/gear-oils',
        image: 'https://storage.googleapis.com/fixcraft-public/spare-parts-ecom/v-motive/family/TRANSMISSION%20OIL.png',
        keyId: 7,
        label: 'Gear Oils: The Importance of Lubrication for Your Vehicle',
    },
    {
        url: '/blogs/oil-filter',
        image: 'https://storage.googleapis.com/fixcraft-public/spare-parts-ecom/v-motive/family/OIL%20FILTER.png',
        keyId: 8,
        label: 'Oil filters',
    },
    {
        url: '/blogs/washer-fluid',
        image: 'https://storage.googleapis.com/fixcraft-public/spare-parts-ecom/v-motive/family/Windshield%20Washer%20Fluid.png',
        keyId: 9,
        label: 'Windshield Washer Fluid: The Secret to Crystal Clear Windshields',
    },
    {
        url: '/blogs/wipers',
        image: 'https://storage.googleapis.com/fixcraft-public/spare-parts-ecom/v-motive/family/WIPER%20BLADE.png',
        keyId: 10,
        label: 'The Importance of Quality Windshield Wipers',
    },
    { url: '/blogs/coolants', image: '/images/product/CoolantRed.png', keyId: 11, label: 'Coolants' },
];

function BlogFooterNavigator(keyId: any) {
    const prevKey = keyId === 1 ? 10 : keyId - 2;
    const nextKey = keyId === 11 ? 0 : keyId;
    return (
        <div className="post-view__card post-navigation">
            <div className="post-navigation__body">
                <AppLink
                    href={`${BLOGS_DATA[prevKey]?.url}`}
                    className="post-navigation__item post-navigation__item--prev"
                >
                    <div className="post-navigation__item-image">
                        <AppImage src={`${BLOGS_DATA[prevKey]?.image}`} />
                    </div>
                    <div className="post-navigation__item-info">
                        <div className="post-navigation__direction">
                            <div className="post-navigation__direction-arrow">
                                <ArrowRoundedLeft7x11Svg />
                            </div>
                            <div className="post-navigation__direction-title">Previous post</div>
                        </div>
                        <div className="post-navigation__item-title">{`${BLOGS_DATA[prevKey]?.label}`}</div>
                    </div>
                </AppLink>

                <AppLink
                    href={`${BLOGS_DATA[nextKey]?.url}`}
                    className="post-navigation__item post-navigation__item--next"
                >
                    <div className="post-navigation__item-info">
                        <div className="post-navigation__direction">
                            <div className="post-navigation__direction-title">Next post</div>
                            <div className="post-navigation__direction-arrow">
                                <ArrowRoundedRight7x11Svg />
                            </div>
                        </div>
                        <div className="post-navigation__item-title">{`${BLOGS_DATA[nextKey]?.label}`}</div>
                    </div>
                    <div className="post-navigation__item-image">
                        <AppImage src={`${BLOGS_DATA[nextKey]?.image}`} />
                    </div>
                </AppLink>
            </div>
        </div>
    );
}

export default BlogFooterNavigator;
